FD.Cookies = (function ($, me) {
    'use strict';

    me.Cookies = me.Cookies || {};

    /* ========================================================================
     *  Private Variables
     * ========================================================================
    */


    /* ========================================================================
     *  Private Methods
     * ========================================================================
    */


    /* ========================================================================
     *  Public Methods
     * ========================================================================
    */


    me.Cookies.get = function (key) {
        key += '=';
        const allCookies = document.cookie.split(';');
        for (let i = 0; i < allCookies.length; i++) {
            let current = allCookies[i].trim();
            if (current.indexOf(key) === 0) {
                return current.substring(key.length, current.length);
            }
        }
        return null;
    };


    me.Cookies.set = function (key, value, days) {
        let date = new Date();
        days = days || 31;
        date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
        const expires = "; expires=" + date.toUTCString();
        document.cookie = key + "=" + value + expires + "; path=/";
    };


    /* ========================================================================
     *  return
     * ========================================================================
    */
    return me.Cookies;
}(jQuery, FD));